// extracted by mini-css-extract-plugin
export default {"button-container":"NextButton_button-container__f3i58","button":"NextButton_button__sZNpy"};